import { Component } from '@angular/core';
import { Sharedservice } from './shared-components/shared.service';
import { UserModel } from './models/user.model';
import { UserService } from './services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageConstants } from './shared-components/constant';
import { HttpClient } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeZh from '@angular/common/locales/zh';
import { AppConfigurationService } from './services/appConfiguration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  userModel: UserModel = new UserModel();
  forAuthorizedUser = false;
  loadspinner = true;
  isPrivacyPolicyAgreed: boolean;
  DEFAULT_LANGUAGE = LanguageConstants.US_ENG_LOCALE;

  constructor(private userService: UserService, public sharedService: Sharedservice, private translateService: TranslateService, private appconfigService: AppConfigurationService,
    private http: HttpClient
  ) {
    registerLocaleData(localeEs);
    registerLocaleData(localeZh);

    // Adds all language packs.
    this.translateService.addLangs([LanguageConstants.US_ENG_LOCALE, LanguageConstants.SPANISH_LOCALE,
    LanguageConstants.GERMAN_LOCALE, LanguageConstants.CHINESE_LOCALE]);
    // Sets Default language as "US-English".
    this.translateService.setDefaultLang(LanguageConstants.US_ENG_LOCALE);
    // Adds to local storage.
    localStorage.setItem(LanguageConstants.LANG_CODE, this.DEFAULT_LANGUAGE);

    if (this.translateService.translations[this.DEFAULT_LANGUAGE] === undefined) {
      this.http.get(`../assets/i18n/${this.DEFAULT_LANGUAGE}.json`).subscribe((i18n) => {
        this.translateService.setTranslation(this.DEFAULT_LANGUAGE, i18n, true);
      });
    }

    this.loadspinner = true;

    setTimeout(() => {
      // Allow only AD User Group users
      this.forAuthorizedUser = true;
      userService.captureUserProfile().subscribe((resp) => {
        if (resp !== undefined) {
          this.isPrivacyPolicyAgreed = resp[0].IsPrivacyPolicyAgreed;
          this.userService.setLoggedInUserData(resp[0]);
          localStorage.setItem('loggedInUserId', resp[0].Id);
        }
        this.loadspinner = false;
      }, (error) => {
        this.loadspinner = false;
      });
    }, 1000);
    //load configuration from DB
    //this.appconfigService.initialConfigLoading().subscribe(data => {
    //  appconfigService.appConfigurationSubject.next(data);
    //});
  }

  languageChosen(langSelected: string) {
    localStorage.setItem(LanguageConstants.LANG_CODE, langSelected);
    this.translateService.use(langSelected);
  }

  
}
